import { http } from "../ConnectApi/ConnectApi";

export async function UnStakeLockedSharesController(data: { amountShares: any, tokenId: any  }) {
  try {
    const response = await http.post('tftc/blockchain/unstake-locked-shares', data, {
      withCredentials: true
    });

    return response;
  } catch (error: any) {
    console.error('Error during request:', error.response?.data || error.message);
    throw error;
  }
}
